import React from "react";
import { SearchInputProps } from "./Search.props";
import "./Search.css";
import { ReactComponent as SearchIcon } from "common/assets/icons/search.svg";

export const SearchInput: React.FC<SearchInputProps> = ({
	value,
	placeholder = "Search...",
	onChange,
	className,
}) => {
	return (
		<div className={`relative bg-white shadow-xs ${className}`}>
			<input
				type="text"
				value={value}
				onChange={onChange}
				className={`input w-full h-full py-[10px] px-[14px] lg:w-full min-w-[25rem] border placeholder-passiveTextColor rounded-md border-strokeColor transition-all duration-300 text-textColor font-regular `}
				placeholder={placeholder}
			/>
			<span className="absolute inset-y-0 right-0 grid pr-4 place-items-center">
				<SearchIcon className="w-4 h-4 stroke-passiveTextColor" />
			</span>
		</div>
	);
};
